export default __webpack_public_path__ + "static/media/teams-2.074787de.jpg";